import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getPriceRangeString } from 'site-modules/shared/utils/price-utils';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { buildMmysMsrpPricesPath, VehicleModel } from 'client/data/models/vehicle-v2';

function VehiclePriceUI({ msrpPriceRange, priceClassName, labelClassName }) {
  let minPrice = null;
  let maxPrice = null;

  if (msrpPriceRange && msrpPriceRange.length) {
    minPrice = msrpPriceRange[msrpPriceRange.length - 1];
    maxPrice = msrpPriceRange[0];
  }
  const hasPrice = !!(minPrice && maxPrice);
  if (!hasPrice) {
    return null;
  }

  const vehiclePrice = getPriceRangeString(minPrice, maxPrice);
  const priceLabel = `MSRP${minPrice === maxPrice ? '' : ' Range'}`;

  return (
    <Fragment>
      <div className={classnames('label', labelClassName)}>{priceLabel}</div>
      <div className={classnames('d-flex justify-content-between', priceClassName)}>{vehiclePrice}</div>
    </Fragment>
  );
}

VehiclePriceUI.propTypes = {
  msrpPriceRange: PropTypes.arrayOf(PropTypes.number),
  priceClassName: PropTypes.string,
  labelClassName: PropTypes.string,
};

VehiclePriceUI.defaultProps = {
  msrpPriceRange: null,
  priceClassName: 'heading-3',
  labelClassName: null,
};

export const VehiclePrice = connectToModel(VehiclePriceUI, {
  msrpPriceRange: bindToPath(
    ({ vehicle }) =>
      buildMmysMsrpPricesPath({
        make: vehicle.make.slug,
        model: vehicle.model.slug,
        submodel: vehicle.submodels.slug,
        year: vehicle.year,
      }),
    VehicleModel
  ),
});
